import { useState, useCallback, useRef } from "react";

export const useGridReset = () => {
  const [resetGrid, setGridReset] = useState(false);

  return {
    resetGrid,
    setGridReset,
  };
};
